import { TaskT } from 'ui-io/task-io/task-t'

export type StringKey =
  | 'id'
  | 'assignee'
  | 'companyName'
  | 'configScope'
  | 'configScopeType'
  | 'configScrapeStrategy'
  | 'configUuid'
  | 'lastModifiedBy'
  | 'currentState'
  | 'title'
  | 'type'

const stringExtractors: Record<
  StringKey,
  (task: TaskT) => string | undefined | null
> = {
  id: (task: TaskT) => task.id,
  assignee: (task: TaskT) => task.assignee,
  companyName: (task: TaskT) => task.companyName,
  configScope: (task: TaskT) => task.configScope,
  configScopeType: (task: TaskT) => task.configScopeType,
  configScrapeStrategy: (task: TaskT) => task.configScrapeStrategy,
  configUuid: (task: TaskT) => task.configUuid,
  lastModifiedBy: (task: TaskT) => task.lastModifiedBy,
  currentState: (task: TaskT) => task?.currentState,
  title: (task: TaskT) => task.title,
  type: (task: TaskT) => task.type,
}

export default stringExtractors
